import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import SearchIcon from "../../assets/img/searchIcon";
import CitySingle from "../../components/citySingle/citySingle.component";
import CitySubSingle from "../../components/citySubSingle/citySubSingle.component";
import {
  selectNewRequestCities,
  selectNewRequestSelectedProvince,
  selectNewRequestSelectionLevel,
} from "../../redux/newRequest/newRequest.selectors";

const CityList = ({
  selectNewRequestCities,
  selectNewRequestSelectionLevel,
  selectNewRequestSelectedProvince,
  show,
}) => {
  //   console.log("selectNewRequestCities", selectNewRequestCities.filter(item=>item.provincename ==));
  //   debugger;

  const [search, setSearch] = useState("");

  const inputRef = useRef("");

  useEffect(() => {
    // effect

    inputRef.current.value = "";
    setSearch("");
    // debugger;

    // return () => {
    //   alert("hi");
    // };
  }, [show]);

  //   const filteredCities = selectNewRequestCities.filter(
  //     (item) => item.provincename === search
  //   );
  const handle_input_change = (e) => {
    const value = e.currentTarget.value;
    setSearch(value);

    // debugger;
  };

  return (
    <div>
      <div>
        <div className="position-relative">
          <input
            ref={inputRef}
            onChange={handle_input_change}
            className="custom--input"
            type="text"
          />
          <div
            className="position-absolute"
            style={{ left: "7px", top: "7px" }}
          >
            <SearchIcon />
          </div>
        </div>
      </div>
      <div
        className="text-center overflow-auto"
        style={{ minHeight: "20vh", maxHeight: "80vh" }}
      >
        {selectNewRequestSelectionLevel === 0
          ? selectNewRequestCities
              .filter((item) => item.provincename.startsWith(search))
              ?.map((city) => <CitySingle key={city._id} info={city} />)
          : selectNewRequestSelectionLevel === 1 ||
            selectNewRequestSelectionLevel === 2
          ? selectNewRequestSelectedProvince._city
              .filter((item) => item.shahrname.startsWith(search))
              ?.map((city) => <CitySubSingle key={city._id} info={city} />)
          : null}
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestCities: selectNewRequestCities,
  selectNewRequestSelectionLevel: selectNewRequestSelectionLevel,
  selectNewRequestSelectedProvince: selectNewRequestSelectedProvince,
});

export default connect(mapStateToProps)(CityList);
